module.exports = __webpack_public_path__ + "img/wind_rune.1eeecf4f.png";